import { render, staticRenderFns } from "./IssueUpgrade.vue?vue&type=template&id=5f5bcf48&scoped=true&"
import script from "./IssueUpgrade.vue?vue&type=script&lang=js&"
export * from "./IssueUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./IssueUpgrade.vue?vue&type=style&index=0&id=5f5bcf48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bcf48",
  null
  
)

export default component.exports